module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_03.80404cc2.jpg";